import { encodeQueryData } from 'Utils/Common';
import http from './httpService';
const API_URL_TARGET = process.env.REACT_APP_API_URL_TARGET;


async function getAllBankContact(params:any) {
    const url = `${API_URL_TARGET}get_all_bank_contact?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

async function getAllCities(params:any) {
    const url = `${API_URL_TARGET}get_all_cities?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}


async function saveBankContact(obj:any) {
    const url = `${API_URL_TARGET}save_bank_contact`;
    let response = await http.post(url, obj);
    return response;
}

async function updateBankContact(obj:any,id:any) {
    const url = `${API_URL_TARGET}update_bank_contact/${id}`;
    let response = await http.put(url, obj);
    return response;
}

async function saveBank(obj:any) {
    const url = `${API_URL_TARGET}save_bank`;
    let response = await http.post(url, obj);
    return response;
}

async function bankOfferAccess(obj:any) {
    const url = `${API_URL_TARGET}verify-login`;
    let response = await http.post(url, obj);
    return response;
}



const SingleLoanServices = {
    getAllBankContact,
    getAllCities,
    saveBankContact,
    updateBankContact,
    saveBank,
    bankOfferAccess,
};

export default SingleLoanServices;